import Vue from "vue";
import VueRouter from "vue-router";

import index from "../views/index.vue";
import help1 from "../views/help1.vue";
import help2 from "../views/help2.vue";
import help3 from "../views/help3.vue";
import help4 from "../views/help4.vue";
import help5 from "../views/help5.vue";
import help6 from "../views/help6.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "indexPage",
    component: index,
    meta: { title: "帮助中心" },
  },
  {
    path: "/help1",
    name: "help1Page",
    component: help1,
    meta: { title: "帮助中心" },
  },
  {
    path: "/help2",
    name: "help2Page",
    component: help2,
    meta: { title: "帮助中心" },
  },
  {
    path: "/help3",
    name: "help3Page",
    component: help3,
    meta: { title: "帮助中心" },
  },
  {
    path: "/help4",
    name: "help4Page",
    component: help4,
    meta: { title: "帮助中心" },
  },
  {
    path: "/help5",
    name: "help5Page",
    component: help5,
    meta: { title: "帮助中心" },
  },
  {
    path: "/help6",
    name: "help6Page",
    component: help6,
    meta: { title: "帮助中心" },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
